module.exports = __webpack_public_path__ + "img/aplicaciones_moviles.9e603758.png";